<template>
  <div class="map-drag">
    <headerBack :backParams="backParams" @backBtn="back"></headerBack>
    <div id="container"></div>
    <div class="drag-name">
      <div class="name-address">
        <div class="name-word" v-if="mapDragPointInfo.regeocode">{{mapDragPointInfo.regeocode.pois[0]['name']}}</div>
        <div class="address-word">{{mapDragPointInfo.nearestJunction}}</div>
      </div>
      <div class="name-confirm" @click="confirmDrag(mapDragPointInfo)">确认</div>
    </div>
  </div>
</template>
<script>
// 地图选点
import wx from 'weixin-js-sdk'
import { mapGetters } from 'vuex'
import headerBack from '@/components/headerBack'
import AMap from 'AMap'
import AMapUI from 'AMapUI'
import {setLocalStorage, getLocalStorage} from '@/utils/session.js'
export default {
  name: 'mapDragPoint',
  components: {headerBack, AMap, AMapUI},
  data () {
    return {
      backParams: {
        title: '地图选点'
      },
      searchType: '', // 其他页面传递的参数
      mapDragPointInfo: {}, // 选点结果数据
      latAndLng: {}
    }
  },
  computed: {
    ...mapGetters([])
  },
  mounted () {
    this.getLatAndLng()
    this.searchType = this.$session.getLocalStorage('searchType') || this.$route.params.searchType
    this.initMap()
    this.$wxHide()
  },
  methods: {
    back () {
      this.$router.push({name: 'searchStation'})
    },
    getLatAndLng () {
      let latAndLng = getLocalStorage('LatLng') || {}
      if (latAndLng  && latAndLng.lat && latAndLng.lng) {
        this.latAndLng = latAndLng
      } else {
        wx.ready(() => { // 需在用户可能点击分享按钮前就先调用
          wx.getLocation({
            type: 'gcj02', // 默认为wgs84的gps坐标，如果要返回直接给openLocation用的火星坐标，可传入'gcj02'
            success: (res) => {
              const position = {
                lat: res.latitude,
                lng: res.longitude
              }
              this.latAndLng = position
              setLocalStorage('LatLng', position)
            }
          })
        })
      }
    },
    // 初始化地图 并且定位+搜索+选点
    initMap () {
      let self = this
      AMapUI.loadUI(['misc/PositionPicker'], function(PositionPicker) {
        let map = new AMap.Map('container', {
          resizeEnable: true,
          center: [self.latAndLng.lng || self.$cityCode.lng, self.latAndLng.lat || self.$cityCode.lat], // 地图中心点
          zoom: 15, // 地图显示的缩放级别
          viewMode: '3D'
        })
        // 拖拽选点
        let positionPicker = new PositionPicker({
          mode: 'dragMap',
          map: map
        })
        positionPicker.on('success', function (positionResult) {
          self.mapDragPointInfo = positionResult
        })
        positionPicker.on('fail', function (positionResult) {
          // console.log(positionResult)
        })
        positionPicker.start() // 开始拖拽选址
        map.panBy(0, 1)
      })
    },
    // 选点结果确认返回搜索页面
    confirmDrag (obj) {
      const params = {
        type: this.searchType,
        name: obj.regeocode.pois[0]['name'],
        address: obj.nearestJunction,
        lat: obj.position.lat,
        lng: obj.position.lng
      }
      // 根据查询的起始和终点缓存相应的数据，以备后期使用
      if (this.searchType === 'start') {
        this.$store.dispatch('save_startStation', params)
      } else {
        this.$store.dispatch('save_endStation', params)
      }
      this.$router.push({name: 'transfer', params: {backSearchObj: params}})
    }
  }
}
</script>
<style lang="scss" scoped>
.map-drag {
  width: 100%;
  height: 100vh;
  overflow: hidden;
  #container {
    width: 100%;
    height: calc(100vh - 120px);
  }
  .drag-name{
    width: 100%;
    height: 70px;
    display: flex;
    align-items: center;
    overflow: hidden;
    font-size: 16px;
    position: absolute;
    bottom: 0px;
    .name-address{
      flex: 1 auto;
      border-right: 1px solid #C0BFC4;
      display: flex;
      flex-direction: column;
      justify-items: center;
      .name-word {
        padding-left: 10px;
        overflow:hidden;
        text-overflow:ellipsis;
        white-space:nowrap;
      }
      .address-word{
        padding-left: 10px;
        overflow:hidden;
        text-overflow:ellipsis;
        white-space:nowrap;
        font-size: 14px;
        color: #999999;
      }
    }
    .name-confirm{
      width:  100px;
      height: 70px;
      text-align: center;
      line-height: 70px;
      font-size: 16px;
      color: #1989fa;
    }
  }
}
</style>
